// Vue
import {mixins} from 'vue-class-component'
import {Vue, Component, Prop, Watch} from 'vue-property-decorator'

// Template
import template from './template.vue'

// Mixins
import {EventBus} from '../../../../mixins/event_bus/EventBus'

@Component({
    name: 'TileGroup',
    mixins: [
        template
    ]
})
export class TileGroup extends mixins(EventBus) {


    @Prop()
    public height!: number

    @Watch('height')
    public watchHeight(height, oldHeight) {
        this.broadcast('Tile', 'groupHeightChange', [height])
    }

    public created () {

    }

    public mounted() {
        this.broadcast('Tile', 'groupHeightChange', [this.height])
    }

    public destroyed() {

    }
}